module.exports = __webpack_public_path__ + "static/img/5.7c79814.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting584/images/5.png
// module id = upGN
// module chunks = 4